(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-section-1"] && !window.DesignMode) return;
  try {
    
  // FAQ Accordion functionality
const accordionItems = document.querySelectorAll('.accordion-item');

accordionItems.forEach(item => {
    const header = item.querySelector('.accordion-header');
    const content = item.querySelector('.accordion-content');
    const icon = item.querySelector('.accordion-icon');
    
    // Set initial state
    if (item.classList.contains('active')) {
        icon.textContent = '-';
    } else {
        icon.textContent = '+';
    }
    
    header.addEventListener('click', function() {
        // Toggle active class
        const isActive = item.classList.contains('active');
        
        // Toggle the state
        if (isActive) {
            item.classList.remove('active');
            icon.textContent = '+';
        } else {
            item.classList.add('active');
            icon.textContent = '-';
        }
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-to-apply"] && !window.DesignMode) return;
  try {
    
  // How to Apply tabs functionality
const howToTabs = document.querySelectorAll('.how-to-tab');
const stepLists = document.querySelectorAll(".steps-list");

howToTabs.forEach(tab => {
    tab.addEventListener('click', function() {
        // Remove active class from all tabs
        howToTabs.forEach(t => t.classList.remove('active'));
        stepLists.forEach(t => t.classList.remove('show-tab'));
        
        // Add active class to clicked tab
        this.classList.add('active');
        
        // Add 'show-tab' to the corresponding pane
        const howTabId = tab.dataset.tabType;
        const activePane = document.querySelector(`#${howTabId}`);

        if (activePane) {
            activePane.classList.add('show-tab');
        }
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-showcase"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const tabsContainer = document.querySelector('.showcase-tabbed-showcase');
    if (!tabsContainer) return;

    // console.log("tabsContainer: ", tabsContainer);
    const tabs = tabsContainer.querySelectorAll('.showcase-tab');
    const tabContents = tabsContainer.querySelectorAll('.showcase-tab-content');

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const targetId = tab.getAttribute('data-tab');
        const targetContent = document.getElementById(targetId);

        // Deactivate all tabs and content
        tabs.forEach(t => t.classList.remove('active'));
        tabContents.forEach(c => c.classList.remove('active'));

        // Activate clicked tab and corresponding content
        tab.classList.add('active');
        if (targetContent) {
          targetContent.classList.add('active');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !window.DesignMode) return;
  try {
    
  // Testimonial Slider functionality
const testimonialSlides = document.querySelectorAll('.testimonial-slide');
const testimonialNavBtns = document.querySelectorAll('.testimonial-nav-btn');

// Set up automatic slider
let currentSlide = 1;
let testimonialInterval;

function startTestimonialInterval() {
    testimonialInterval = setInterval(() => {
        currentSlide = currentSlide >= testimonialSlides.length ? 1 : currentSlide + 1;
        showTestimonialSlide(currentSlide);
    }, 5000); // Change slide every 5 seconds
}

function showTestimonialSlide(slideNumber) {
    // Hide all slides and remove active class from nav buttons
    testimonialSlides.forEach(slide => {
        slide.classList.remove('active');
    });
    
    testimonialNavBtns.forEach(btn => {
        btn.classList.remove('active');
    });
    
    // Show the selected slide and activate corresponding nav button
    const slideToShow = document.querySelector(`.testimonial-slide[data-slide="${slideNumber}"]`);
    const btnToActivate = document.querySelector(`.testimonial-nav-btn[data-slide="${slideNumber}"]`);
    
    if (slideToShow && btnToActivate) {
        slideToShow.classList.add('active');
        btnToActivate.classList.add('active');
        currentSlide = slideNumber;
    }
}

// Add click event listeners to navigation buttons
testimonialNavBtns.forEach(btn => {
    btn.addEventListener('click', function() {
        const slideNumber = parseInt(this.getAttribute('data-slide'));
        showTestimonialSlide(slideNumber);
        
        // Reset the interval when manually changing slides
        clearInterval(testimonialInterval);
        startTestimonialInterval();
    });
});

// Start the automatic slider when the page loads
startTestimonialInterval();

  } catch(e) { console.error(e); }
})();
})();
